module.exports = __webpack_public_path__ + "img/swap-left.19539e4c.svg";